import {buildField} from '@eitje/form'
import * as React from 'react'
import {DatePicker} from '~/components'
import {DISPLAYED_DATE_FORMAT} from '~/components/date_based_pickers/helpers'
import * as _ from 'lodash'
import {DatePickerFieldTrigger} from '../root'

export const DatePickerField = React.memo(
	buildField(
		fieldProps => {
			return (
				<DatePicker
					{...fieldProps}
					renderTrigger={ctx => {
						const hasValue = Boolean(ctx.value)
						let displayValue = fieldProps.placeholder

						if (hasValue && !fieldProps.displayFormatFn) displayValue = ctx.value.format(DISPLAYED_DATE_FORMAT)
						if (hasValue && fieldProps.displayFormatFn) {
							displayValue = fieldProps.displayFormatFn(ctx.value)
						}

						return <DatePickerFieldTrigger isPlaceholderShown={!hasValue}>{displayValue}</DatePickerFieldTrigger>
					}}
				/>
			)
		},
		{className: 'date-picker-field', icon: true},
	),
	_.isEqual,
)
